<micro-lookup domain="domain" obj="nes" url="/nes" [key]="neId"></micro-lookup>
